import React, { useRef, useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet";

import MainLayout from "../../Layouts/Main_Layout";
import Header from "../../Header/header";
import HeaderMenu from "../../Header/header-menu";
import Isi from '../../ISI/Isi';
import IsiFrame from '../../ISI/Isi-frame';
import Footer from "../../Footer/Footer";

import VideoComponent from "../../VideoComponent";
import Modal from '../Modal';
import './muhammad-ali.css'

export default function MuhammadAli() {
  const navigate = useNavigate();
  const myRef = useRef(null)
  const url = process.env.REACT_APP_API_URL;
  const [show, setShow] = useState(true);
  const [anonId, setAnonId] = useState("");
  const [activePd, setActivePD] = useState(false);
  const [activeEx, setActiveEx] = useState(false);
  const [imagesLoaded, setImagesLoaded] = useState(false);

  // ali video specific
  const [showAli, setShowAli] = useState(false);
  const location = useLocation();

  const executeScroll = () => {
    myRef.current.scrollIntoView();
    setShow(true)
  }

  const handleVideoClick = (clickClass) => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag('event', 'ali_video', {
        'event_category': 'video_start',
        'event_label': clickClass,
        'page_location': window.location.href
      });
    }
  }

  const handleImageLoads = () => {
    // Check if all images have finished loading
    const allImagesLoaded = Array.from(document.querySelectorAll('img')).every((image) => image.complete);

    if (allImagesLoaded) {
      setImagesLoaded(true);
    }
  };

  useEffect(() => {
    if (location.hash === '#watch-ali-video') {
      setShowAli(true);
    }
  }, [location]);

  useEffect(() => {

    const getCookieValue = (cookieName) => {
      const cookieValue = document.cookie
        .split('; ')
        .find(row => row.startsWith(cookieName + '='))
        ?.split('=')[1];

      return cookieValue;
    };

    const calculateOffset = () => {
      const componentElement = myRef.current;

      if (myRef) {
        const offsetTop = componentElement.offsetTop;
        function handleScroll() {
          if (window.innerHeight + window.scrollY > offsetTop) {
            setShow(false);
          }
          else (
            setShow(true)
          )
        }

        window.addEventListener("scroll", handleScroll);
        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
      }
    };
    calculateOffset();
    const anonID = getCookieValue('Anon_ID');
    setAnonId(anonID)
    window.addEventListener('resize', calculateOffset);
    return () => {
      window.removeEventListener('resize', calculateOffset);
    };
  }, []);

  if (imagesLoaded) {
    var header = document.getElementById('submenu');

    window.addEventListener('scroll', function () {
      var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      const offsetTop = header.offsetTop;
      if (scrollPosition > offsetTop) {
        header.classList.add('sticky');
      } else {
        header.classList.remove('sticky');
      }
    });
  }

  return (
    <MainLayout>
      <div className="muhammed-ali">
        <Helmet>
          <title>Muhammed Ali | INBRIJA® (levodopa inhalation powder)</title>
          <meta property='og:title' content={`Muhammed Ali | INBRIJA® (levodopa inhalation powder)`} />
          <meta property='og:description' content={`Learn about the return of Parkinson's symptoms between doses of medication, sometimes referred to as OFF periods. See Indication, Important Safety Information, and Patient Information Leaflet.`} />
          <meta property='og:site_name' content='INBRIJA.COM' />
          <meta property='og:type' content='website' />
          <meta name='description' content={`Learn about the return of Parkinson's symptoms between doses of medication, sometimes referred to as OFF periods. See Indication, Important Safety Information, and Patient Information Leaflet.`} />
          <meta property="og:image" content="https://inbrija.com/assets/images/Inbrija-OG-Image.jpg" />
          <meta property='og:url' content='https://inbrija.com/muhammad-ali' />
          <meta property='og:image:alt' content='INBRIJA logo' />
        </Helmet>
        <Header />
        <HeaderMenu>
          <div className="container-1500">
            <div className="hero-section pt-5 pt-md-4 pt-lg-5 pb-4 pb-md-0">
              <div className="hero-section-content pe-5 pb-4">
                <h1>Channeling their inner <span>FIGHTER...</span> Inspired by Ali</h1>
              </div>
              <div className='hero-section-image'>
                <img onLoad={handleImageLoads} className='img-fluid' src="/assets/images/2025-01-26_AliPage_Hero_Trans.png" alt="" />
                <div className="ali-disclaimer">Muhammad Ali was<br className="d-block d-md-none" /> not an INBRIJA patient.</div>
                <div className="actor-portrayal">Actor portrayal.</div>
              </div>
            </div>
          </div>
        </HeaderMenu>

        <div className="menu-bar-sticky-desktop" id="submenu-div">
          <div className="brush-style" id="submenu">
            <div className="submenu-style"></div>
          </div>
        </div>
        <div className="menu-bar-sticky-mobile">
          <div className="brush-style mobile-header-sticky">
          </div>
        </div>

        <div id="video-bar" className="container py-5 d-flex flex-column px-4">
          <div className="pd-container col-12 col-md-9 mx-auto mb-4">
            <h2>With Parkinson's disease, every day<br className="d-block d-md-none" /> is a fight</h2>
            <h3 className="">Living with Parkinson's disease means facing challenges daily—ones that many people may take for granted.</h3>
            <p className="mb-4">Yet, in the face of these challenges, individuals with Parkinson's and their care partners show extraordinary strength, resilience, and determination.<br className="d-block d-md-none" /> This is who we celebrate.</p>
 
            <div className="video-container d-flex align-items-center justify-content-center">
              <VideoComponent patientId="play-ali-video" hash={location.hash} patientImage="/assets/images/muhammad-ali-inbrija.jpg" title="Ali's Story" alt={`Split screen of Muhammad Ali and older man punching the camera`} onClick={() => { setShowAli(true); handleVideoClick('ALI_watch_ali') }} />
            </div>
 
          </div>
        </div>

        <div id="ali-celebrating" className="gray-bar text-white text-left d-flex py-4">
          <div className="container-1500">
            <div className="row align-items-center position-relative">
              <div className="col-12 col-md-7 col-xl-6 offset-xl-1 content ps-5">
                <h3 className=""><span>CELEBRATING</span><br className="d-md-none" /> the fighters.</h3>
                <p className="mb-5 pe-3">Despite the unpredictable nature of Parkinson&rsquo;s, so many in the community refuse to be defined by it. They stay active. They box. They exercise. They adapt, persevere, and continue to live full, meaningful lives. Their fight is daily, their spirit unyielding. Parkinson's may present barriers, but it does not define the outcome.</p>
                <Link to="/inbrija-stories" className="btn yellow-border-btn px-4 mb-4" id="btn-ali-fight-back">Meet the Fighters <span className="forward-angle ms-2"></span></Link>
              </div>
              <div className="col-md-5 col-xl-4 content-image">
              </div>
            </div>
          </div>
        </div>

        <div className="yellow-brush-border"></div>

        <div id="ali-inspired" className="gray-bar text-white text-left position-relative">
          <div className="container-fluid">
            <div className="row align-items-center position-relative">
              <div className="content-image col-md-6 col-lg-5">
              </div>
              <div className="content col-12 col-md-6 col-lg-7 col-xl-6 col-xxl-5 px-5 pb-sm-4 ps-md-3 pe-md-5 ps-lg-5 ">
                <h3 className="pt-5"><span>INSPIRED</span><br className="d-md-none" /> by the greatest fighter</h3>
                <p className="mb-3 mb-md-5">Muhammad Ali, one of the most legendary athletes in history, became a global symbol not just for his victories in the ring, but for the grace, courage, and strength with which he faced Parkinson's disease. His courage serves as a powerful reminder that being a fighter is about more than physical strength—it's about resilience, spirit, and never backing down.</p>
                <div className="mb-0"><img src="/assets/images/mae-mobile-ali-winning.png" id="img-ali-winning" className="d-sm-none img-fluid" alt="Ali winning" /></div>
              </div>
            </div>
          </div>
        </div>

        <div className="position-relative">
          <div className="container">
            <div className="row py-5">
              <div className="col-12 col-md-6 content text-center">
                <div className="mb-5"><img src="/assets/images/icon-support.png" alt="" /></div>
                <h4 className="fw-bold mb-3 text-purple">Support for the Fight</h4>
                <p className="mb-3">We recognize that Parkinson's is a daily fight. Even with your regular baseline CD/LD medication, symptoms can still return and interrupt your day. That's why <strong>INBRIJA<sup>&reg;</sup></strong>&mdash;a treatment you can use <strong>on-demand, the moment symptoms return</strong> &mdash; was developed. INBRIJA works to help adults with Parkinson's treat those returning symptoms, so you can get back to what matters most. It's one more way we stand beside you—and the entire Parkinson's community&mdash;in this fight.</p>
                <div><Link to="/about-inbrija" id="btn-mae-learn" className="btn btn-purple mb-3">Learn more about INBRIJA</Link></div>
                <div><Link to="/how-to-use-inbrija" id="btn-mae-how" className="btn btn-purple">See how to use INBRIJA</Link></div>
              </div>
              <div className="col-12 col-md-6 text-center">
                <div className="mb-5 mt-5 mt-md-0"><img src="/assets/images/icon-together.png" alt="" /></div>
                <h4 className="fw-bold mb-3 text-purple">Together, We Keep Fighting</h4>
                <p>Every person with Parkinson's, every care partner, and every supporter is part of this ongoing fight. We honor your strength. We recognize your courage. And we walk beside you, every step of the way, with the resources you need to fight back. Remember that your doctor is also in your corner to help get the care you need. Our Doctor Discussion Guide can help you prepare to talk to your doctor about returning Parkinson's symptoms.</p>
                <div><Link id="btn-mae-ddg" className="btn btn-purple btn-rounded" to="/pdfs/doctor-discussion-guide.pdf" target="_blank">Download Doctor Discussion Guide</Link></div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <img src="/assets/images/device-inhaler.png" className="img-fluid" alt="" />
              </div>
            </div>
          </div>
        </div>

        <div id="join-community" className="container-fluid gray-bar text-white text-left pt-5 pt-md-0 pb-5 pb-md-0">
          <div className="row">
            <div className="col-12 col-md-6 col-lg-7 col-xxl-6 offset-lg-1 offset-xxl-1 px-5 px-md-5 py-md-5">
              <h2 className="text-white">This is more than a disease.<br className="d-none d-md-block" /> This is a community of fighters.</h2>
              <p>Symptom return can take you out of the moment, disrupting your day and may even cause you to leave activities and events early when you feel symptoms emerging.</p>
              <p className="mb-4">This can look like missing work or not going out to eat, seeing friends and family, and/or participating in your favorite activities.</p>
              <Link to="/sign-up" id="btn-mae-join" className="btn yellow-border-btn">Join Our Community of Fighters <span className="forward-angle"></span></Link>
            </div>
            <div id="mae-mid-fight" className="col-12 col-md-6 col-lg-4">
            </div>
          </div>
        </div>

        <div className="navigation-bar">
          <div className="row">
            <div className="col-md-6">
              <Link to="/inbrija-stories" id="btn-mae-watch" className="d-flex flex-column align-items-center"> 
                <img src="/assets/images/play-rect.svg" className="img-fluid mb-3" alt="" />
                <div>Watch INBRIJA in Action <span className="forward-angle ms-1"></span></div>
              </Link>
            </div>
            <div className="col-md-6">
              <Link to="/pdfs/doctor-discussion-guide.pdf" target="_blank" id="btn-about-prepare" className="d-flex flex-column align-items-center">
                <img src="/assets/images/icon-circle-plus.svg" className="d-block mx-auto pb-2" alt="" /> Prepare for Discussions<br /> With Your Doctor
              </Link>
            </div>
          </div>
        </div>

        <Modal show={showAli} src="/videos/muhammad-ali-inbrija.mp4" title="Muhammad Ali" handleClose={() => { setShowAli(false); navigate(window.location.pathname); }} videoTrack="/videos/muhammad-ali-inbrija.vtt" transcript="" />

        <div ref={myRef}>
          <Isi />
        </div>
        {show ? <IsiFrame onClick={executeScroll} /> : ''}
        <Footer partNum="1/2026 US-INB-2500133" />
      </div>
    </MainLayout>
  )
}